import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "summary-radio-group border border-3 rounded-top" }
const _hoisted_2 = ["value", "checked", "onChange"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "summary-radio-option-description border-3 border-bottom border-start border-end rounded-bottom" }
const _hoisted_6 = {
  key: 0,
  class: "px-3 pt-3 pb-0"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "px-3 pb-3"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryRadioGroup',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const emitUpdate = (value: string | number) => {
  emit('update:modelValue', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
        return (_openBlock(), _createElementBlock("label", {
          key: option.type,
          class: _normalizeClass(["summary-radio-option border-3", { 'active': _ctx.modelValue === option.type, 'border-end': index !== _ctx.options.length - 1, 'rounded-top-left': index === 0, 'rounded-top-right': index === _ctx.options.length - 1 }])
        }, [
          _createElementVNode("input", {
            type: "radio",
            value: option.type,
            checked: _ctx.modelValue === option.type,
            onChange: ($event: any) => (emitUpdate(option.type))
          }, null, 40, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("i", {
              class: _normalizeClass(`bi ${option.icon}`)
            }, null, 2),
            _createElementVNode("p", _hoisted_4, _toDisplayString(option.abbreviation ? `${option.name} (${option.abbreviation})` : option.name), 1)
          ])
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: option.type
        }, [
          (_ctx.modelValue === option.type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.description, (p, i) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: i,
                    class: _normalizeClass({ 'mb-1': i == option.description.length - 1 }),
                    innerHTML: p
                  }, null, 10, _hoisted_7))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      (_ctx.$slots.extraContent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _renderSlot(_ctx.$slots, "extraContent", { selected: _ctx.modelValue })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})